import React, { Fragment, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@pearsontechnology/aero-components';
import StyledLink from 'components/StyledLink';
import mercuryContext from 'ConnectionManager/mercuryContext';
import { getGradeSummaryByActivity } from './manualGradesSummary';
import { Item, Menu } from './components';
import { INCOMPLETE_ATTEMPT, NOT_ATTEMPTED, INSTRUCTOR_UNSCORED } from '../scoreReason';

const ActivityGradesMenu = ({ studentId, cohortId, deploymentId, walkableId, workspaceId }) => {
  const { apolloClient } = useContext(mercuryContext);

  const [loading, setLoading] = useState(true);
  const [presentationData, setPresentationData] = useState(null);

  useEffect(
    () => {
      setLoading(true);
      if (!apolloClient || !workspaceId || !cohortId || !deploymentId || !walkableId || !studentId) {
        return () => { };
      }

      getGradeSummaryByActivity(apolloClient, workspaceId, cohortId, deploymentId, walkableId, studentId)
        .then((results) => {
          const isIncomplete = (reason) => [INCOMPLETE_ATTEMPT, NOT_ATTEMPTED].includes(reason);
          const getLink = (child) => isIncomplete(child.gradeReport.state)
            ? null
            : `/classes/${cohortId}/review/${deploymentId}/${child.gradableComponent.parentId}/${child
              .gradableComponent.componentId}/${studentId}`;

          const getGradeState = (child) => {
            if (child.gradeReport.state === INSTRUCTOR_UNSCORED) {
              return 'Grade';
            }
            if (isIncomplete(child.gradeReport.state)) {
              return `\u2014/${child.gradableComponent.maxScore}`;
            }
            return `${child.gradeReport.score}/${child.gradableComponent.maxScore}`;
          };

          const components = [...Object.values(results.children).flat(), ...results.directManualGrades];

          const items = components
            .map((child) => ({
              title: child.gradableComponent.componentConfiguration.title || '',
              id: child.gradableComponent.componentId,
              link: getLink(child),
              status: getGradeState(child),
            }))
            .sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }));

          setPresentationData(items);
          setLoading(false);
        })
        .catch((error) => {
          throw new Error(error);
        });

      return () => { };
    },
    [apolloClient, cohortId, deploymentId, studentId, walkableId, workspaceId],
  );

  return (
    <Fragment>
      {loading ? (<Spinner style={{ margin: '1em auto' }} />) : (
        <Menu>
          {presentationData.map((item) => (
            <Item key={item.id}>
              <span>{item.title}</span>
              {item.link ? <StyledLink to={item.link}>{item.status}</StyledLink> : <span>{item.status}</span>}
            </Item>
          ))}
        </Menu>
      )}
    </Fragment>
  );
};

ActivityGradesMenu.propTypes = {
  studentId: PropTypes.string,
  cohortId: PropTypes.string,
  deploymentId: PropTypes.string,
  workspaceId: PropTypes.string,
  walkableId: PropTypes.string,
};

export default ActivityGradesMenu;
